import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
  Badge,
  Button,
  UncontrolledTooltip,
  Input,
} from "reactstrap";
import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { useNavigate } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE, STATUS_OPTIONS } from "components/constant";
import { urlEncodedId } from "components/CommonComponents/encodeDecodeFunction";
import { showAlert } from "components/CommonComponents/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrainingCenterList,
  editTrainingCenter,
} from "action/trainingCenter";
import NotificationAlert from "react-notification-alert";
import { trainingCenterList } from "constants/trainingCenter";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { REGEX } from "constants/CommonConstants";

function TrainingCenter() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;

  const navigate = useNavigate();
  const notificationAlertRef = useRef(null);
  const { notify } = useContext(NotificationContext);
  const [pageNum, setPageNum] = useState(1);

  const dispatch = useDispatch();
  const trainingCentersDataList = useSelector(
    (state) => state.trainingCenters.trainingCenterList,
  );

  const [trainingCenterListState, setTrainingCenterListState] = useState({
    isLoading: true,
    isSearching: false,
    isUpdatingStatus: false,
    error: "",
    noRecords: false,
  });

  const [searchState, setSearchState] = useState({
    searchStrings: "",
    searchName: "",
    searchAddress: "",
    searchStatus: null,
    filterParams: { filters: "", searchString: "" },
  });

  useEffect(() => {
   getTrainingCenterList(
      dispatch,
      pageNum,
     searchState.filterParams?.filters || "",
    searchState.filterParams?.addressSearch || "",
    );

    return () => {
      dispatch({ type: trainingCenterList, payload: {} });
    };
  }, [pageNum, searchState.filterParams]);

  useEffect(() => {
    if (trainingCentersDataList?.code === 200) {
      setTrainingCenterListState({
        isLoading: false,
        error: "",
        noRecords: trainingCentersDataList?.data?.trainingCenters?.length === 0,
        isSearching: false,
      });
    } else if (
      trainingCentersDataList?.code ||
      trainingCentersDataList?.message
    ) {
      setTrainingCenterListState({
        isLoading: false,
        error:
          trainingCentersDataList?.message || "Failed to load training centers",
        noRecords: false,
        isSearching: false,
      });
    }
  }, [trainingCentersDataList]);

  const formattedData =
    trainingCentersDataList?.data?.trainingCenters?.map((item, index) => {
      return {
        ...item,
        srNo:
          (pageNum - 1) *
            (trainingCentersDataList?.data?.noOfRecordsPerPage ||
              DEFAULT_RECORDS_PER_PAGE) +
          index +
          1,
      };
    }) || [];

  // columns
  const columns = [
    {
      Header: "Sr. No.",
      accessor: "srNo",
      centerAlign: true,
      minWidth: 60,
      maxWidth: 70,
    },
    {
      Header: "Center Name",
      accessor: "name",
      minWidth: 250,
      maxWidth: 250,
      Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    },
    {
      Header: "Full Address",
      accessor: "address",
      minWidth: 210,
      maxWidth: 210,
      Cell: ({ value }) => <div className="text-wrapper">{value}</div>,
    },
    {
      Header: "Status",
      accessor: "status",
      centerAlign: true,
      minWidth: 110,
      maxWidth: 110,
      Cell: ({ value }) => (
        <Badge color={value === "ACTIVE" ? "success" : "warning"} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        const id = row.original.ID;
        const isActive = row.original.status === "ACTIVE";
        const encodedId = urlEncodedId(id);
        return (
          <div className="d-flex  align-items-center">
            <Button
              color="link"
              className="p-0"
              id={`edit${encodedId}`}
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  role === "SUPER_ADMIN"
                    ? `/super-admin/training-center/edit-center/${encodedId}`
                    : `/admin/training-center/edit-center/${encodedId}`,
                  {
                    state: { mode: "edit" },
                  },
                );
              }}
            >
              <i className="fas fa-edit mr-1 table-action-info" />
            </Button>
            <UncontrolledTooltip delay={0} target={`edit${encodedId}`}>
              Edit
            </UncontrolledTooltip>

            <span className="mr-1 text-muted">|</span>

            <Button
              color="link"
              size="lg"
              className="d-flex align-items-center p-0 ml-1"
              id={`status${row.original.ID}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleStatus(row.original);
              }}
            >
              <i
                className={`fas status-toggle-icon ${
                  isActive
                    ? "fa-toggle-on text-success"
                    : "fa-toggle-off text-danger"
                }`}
              />
            </Button>
            <UncontrolledTooltip delay={0} target={`status${row.original.ID}`}>
              {isActive ? "Inactivate" : "Activate"}
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];

  // const confirmStatus = async (data, isActive) => {
  //   try {
  //     const newStatus = isActive ? "INACTIVE" : "ACTIVE";

  //     const res = await editTrainingCenter(data.ID, {
  //       ID: data.ID,
  //       status: newStatus,
  //     });

  //     if (res?.code === 200) {
  //       notify("success", res.message || "Training Center status updated");
  //       // Refresh list to reflect status change
  //       getTrainingCenterList(
  //         dispatch,
  //         pageNum,
  //         searchState.filterParams?.filters || "",
  //         searchState.filterParams?.searchString || "",
  //       );
  //     } else {
  //       const message = Array.isArray(res?.message)
  //         ? res?.message[0]?.Msg
  //         : res?.message || "Failed to update status!";
  //       notify("danger", message);
  //     }
  //   } catch (err) {
  //     notify("danger", err?.message || "Failed to update status!");
  //   } finally {
  //   }
  // };

 const toggleStatus = (data) => {
  const isActive = data.status === "ACTIVE";
  const newStatus = isActive ? "INACTIVE" : "ACTIVE";

  showAlert({
    title: `Are you sure you want to ${
      isActive ? "inactivate" : "activate"
    } this training center?`,
    message: `Training center "${
      data.name
    }" will be marked as ${newStatus.toLowerCase()}.`,
    type: "warning",
    confirmStyle: "deep-blue",
    cancelStyle: "secondary",
    confirmText: "Yes",
    cancelText: "Cancel",
    onConfirm: async (closeAlert) => {
      closeAlert();
     try {
        setTrainingCenterListState((prev) => ({
          ...prev,
          isUpdatingStatus: true,
        }));
       const res = await editTrainingCenter(data.ID, {
          status: newStatus,
        });

        if (res?.code === 200) {
          notify(
            "success",
            res?.message || `Status updated to ${newStatus.toLowerCase()}`
          );

          getTrainingCenterList(dispatch, pageNum, searchState.filterParams);
        } else {
          notify("danger", res?.message || "Failed to update status!");
        }
      } catch (error) {
        notify("danger", error?.message || "Error updating status");
      } finally {
        setTrainingCenterListState((prev) => ({
          ...prev,
          isUpdatingStatus: false,
        }));
      }
    },
  });
};

  const clearSearch = () => {
    setTrainingCenterListState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    setSearchState({
      searchName: "",
      searchAddress: "",
      searchStatus: null,
      filterParams: {
        filters: [],
        addressSearch: "",
      },
    });

    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const buildFilterParams = () => {
    const filterParams = [];
    if (searchState.searchStatus) {
      filterParams.push({
        field: "Status",
        condition: "eq",
        filterValues: [searchState.searchStatus.value],
      });
    }

    if (searchState.searchName) {
      filterParams.push({
        field: "Name",
        condition: "like",
        filterValues: [searchState.searchName],
      });
    }

    return {
      filters: filterParams.length > 0 ? JSON.stringify(filterParams) : [],
      addressSearch: searchState.searchAddress,
    };
  };

  const handleSearchNameChange = (e) => {
    const value = e.target.value;
    if (value === "" || REGEX.ALPHANUMERIC_SPACE_REGEX.test(value)) {
      setSearchState((prev) => ({
        ...prev,
        searchName: value,
      }));
    }
  };

  const handleSearch = () => {
   if (
      !searchState.searchName &&
      !searchState.searchAddress &&
      !searchState.searchStatus
    ) {
      return;
    }

    const newFilterParams = buildFilterParams();
   if (
      JSON.stringify(searchState.filterParams) !==
      JSON.stringify(newFilterParams)
    ) {
      setTrainingCenterListState((prev) => ({
        ...prev,
        isLoading: true,
        isSearching: true,
      }));

      setSearchState((prev) => ({
        ...prev,
        filterParams: newFilterParams,
      }));

      if (pageNum !== 1) setPageNum(1);
    }
  };

   // Custom Option Renderer
    const Option = (props) => {
      return (
        <components.Option {...props}>
          <Badge
            color={props.data.value === "ACTIVE" ? "success" : "warning"}
            pill
          >
            {props.data.label}
          </Badge>
        </components.Option>
      );
    };
  
    // Custom SingleValue Renderer (for the selected value)
    const SingleValue = (props) => {
      return (
        <components.SingleValue {...props}>
          <Badge
            color={props.data.value === "ACTIVE" ? "success" : "warning"}
            pill
          >
            {props.data.label}
          </Badge>
        </components.SingleValue>
      );
    };
  

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <AdminHeader />
      {trainingCenterListState.isUpdatingStatus && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              Updating status... Please wait.
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                 <CardTitle tag="h3" className="mb-0 text-default">
                  Training Centers
                </CardTitle>
                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/training-center/add-center"
                        : "/admin/training-center/add-center",
                      {
                        state: { mode: "add" },
                      },
                    )
                  }
                >
                  <i className="fa fa-plus mr-1" />
                  Training Center
                </Button>
              </CardHeader>

              <CardBody>
                {/* Filters */}
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by center name"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.searchName}
                      onChange={handleSearchNameChange}
                      onKeyDown={handleKeyDown}
                    />

                    <Input
                      type="text"
                      placeholder="Search by address"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.searchAddress}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          searchAddress: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />
                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={STATUS_OPTIONS}
                      placeholder="Select status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                      value={searchState.searchStatus}
                      onChange={(selected) =>
                        setSearchState((prev) => ({
                          ...prev,
                          searchStatus: selected,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />

                    <Button
                      color="default"
                      className={`d-flex align-items-center mb-2 filter-btn btn-deep-blue ${trainingCenterListState.isSearching ? "search-btn" : ""}`}
                      onClick={handleSearch}
                    >
                      {trainingCenterListState?.isSearching ? (
                        <i className="fa fa-spinner fa-spin loader" />
                      ) : (
                        <>
                          <i className="fa fa-search mr-1" />
                          Search
                        </>
                      )}
                    </Button>
                    {(searchState?.filterParams?.filters?.length > 0 ||
                      searchState?.filterParams?.addressSearch) && (
                      <Button
                        color="default"
                        className="d-flex align-items-start mb-2 ml-0 filter-btn btn-deep-blue px-4"
                        onClick={clearSearch}
                      >
                        <i className="fa fa-times mr-1 mt-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className="mt-2 mb-3 mx-1">
                  {trainingCentersDataList?.data?.totalRecords ? (
                    <>
                      {searchState.filterParams?.filters?.length > 0 ? (
                        <span className="total-records">
                          Showing{" "}
                          {trainingCentersDataList?.data?.totalFilteredRecords}{" "}
                          of {trainingCentersDataList?.data?.totalRecords}{" "}
                          Records
                        </span>
                      ) : (
                        <span className="total-records">
                          Total Records :{" "}
                          {trainingCentersDataList?.data?.totalRecords}
                        </span>
                      )}
                    </>
                  ) : null}
                </div>

                {trainingCenterListState?.isLoading ? (
                  <div className="loaderContainer">
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </div>
                ) : trainingCenterListState?.error ? (
                  <>
                    <div className="loaderContainer error-style">
                      <div className="error-icon">
                        <i class="fa-solid fa-circle-exclamation"></i>
                      </div>
                      {trainingCenterListState?.error}
                    </div>
                  </>
                ) : trainingCenterListState?.noRecords ? (
                  <div className="loaderContainer empty-style">
                    <div className="empty-icon">
                      <i class="fa-solid fa-circle-info"></i>
                    </div>
                    <span>No training centers found.</span>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <CommonTable
                      columns={columns}
                      data={formattedData}
                      defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                      activePage={pageNum}
                      setPageNum={setPageNum}
                      totalRecords={
                        trainingCentersDataList?.data?.totalRecords || 0
                      }
                      totalPages={Math.ceil(
                        trainingCentersDataList?.data?.totalFilteredRecords /
                          trainingCentersDataList?.data?.noOfRecordsPerPage ||
                          DEFAULT_RECORDS_PER_PAGE,
                      )}
                      showPaginationBottom={true}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TrainingCenter;
